module.exports = __webpack_public_path__ + "img/bg_03.cfc1270e.jpg";